export enum EPageType {
  THINGS_TODO = 'things-todo'
}
export type Faq = {
  question: string;
  answer: string;
};
export type LinkItem = {
  name: string;
  url: string;
};

export interface RelatedUrl {
  parent: string;
  links: LinkItem[];
}
export interface NeedToKnowItems {
  subheader: string;
  icon: string;
  header: string;
}
export interface City {
  name: string;
  coordinates: {
    lng: number;
    lat: number;
  };
  id: string;
}
export interface Product {
  name: string;
  image: {
    alt: string;
    url: string;
  };
  slug: string;
  type: string;
  duration: number;
}
export interface Trending {
  name: string;
  author: string;
  image: {
    alternativeText: string;
    url: string;
  };
  publication_date: string;
  slug: string;
}
export interface ThingsToDO {
  meta_title: string;
  created_at: {
    _seconds: number;
    _nanoseconds: number;
  };
  canonical: string;
  published: boolean;
  title: string;
  og_image: string;
  og_title: string;
  meta_description: string;
  og_description: string;
  slug: string;
  faqs: Faq[];
  related_urls: RelatedUrl[];
  need_to_know_items: NeedToKnowItems[];
  need_to_know: string;
  city: City;
  products: Product[];
  trending: Trending[];
}
